import React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import { Button, ListItem } from '../../atoms'
import Typography from 'components/atoms/_layouts/Typography'
import WithLabel from 'components/atoms/WithLabel'
import { BREAKPOINT_TABLET_SMALL } from 'static/constants'
import { directReservationService } from '../../../core/services'
import * as interfaces from '../../../static/interfaces'
import I18n from '../../../core/i18n'
import InlineGoogleMap from 'components/organisms/InlineGoogleMap'

declare var window: interfaces.IWindow

const DirectReservationDetail: React.FC<any> = ({ post_data, data, props, ...values }) => {
  const post = post_data
  const reservation = data.direct_reservation
  const [map, setMap] = React.useState(null)
  const [marker, setMarker] = React.useState(null)
  const [isProcessing, setIsProcessing] = React.useState(false)
  const save = async () => {
    setIsProcessing(true)

    const { direct_reservation, flush } = await directReservationService
      .createDirectReservation({
        ...data,
      })
      .catch(error => {
        window.flashMessages.addMessage({ text: error.response.data.errors.auth, type: 'error' })
        return error.response.data
      })
      .finally(() => {
        setIsProcessing(false)
      })
    if (direct_reservation) {
      props.setCreatedDirectReservation(direct_reservation)
      props.setIsCompleted(true)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    }
    window.globalModal.closeModal()
  }
  const cancel = async () => {
    window.globalModal.closeModal()
  }

  return (
    <S.Reservation>
      <ListItem>
        <Typography type="subtitle" size="xl">
          {I18n.t('reservation.detail')}
        </Typography>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('post.post_name')}>{post.name}</WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('generic.tour_schedule')}>
          <Typography>
            {reservation.start_at} - {reservation.end_at}
          </Typography>
        </WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('reservation.number_of_guests')}>
          <div className="person">
            <div className="nb_of">
              <Typography type="subtitle" size="lg">
                {I18n.t('generic.adult')}
              </Typography>
              <Typography type="subtitle" size="lg" color="subtext">
                {I18n.t('generic.nb_of_person', { nb: reservation.num_of_adults })}
              </Typography>
            </div>

            {reservation.num_of_children > 0 && (
              <div className="nb_of">
                <Typography type="subtitle" size="lg">
                  {I18n.t('generic.child')}
                </Typography>
                <Typography type="subtitle" size="lg" color="subtext">
                  {I18n.t('generic.nb_of_person', { nb: reservation.num_of_children })}
                </Typography>
              </div>
            )}

            {reservation.num_of_infants > 0 && (
              <div className="nb_of">
                <Typography type="subtitle" size="lg">
                  {I18n.t('generic.infant')}
                </Typography>
                <Typography type="subtitle" size="lg" color="subtext">
                  {I18n.t('generic.nb_of_person', { nb: reservation.num_of_infants })}
                </Typography>
              </div>
            )}
          </div>
        </WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('generic.total_price')}>¥{reservation.price}</WithLabel>
      </ListItem>

      <ListItem separate={true}>
        <WithLabel label={I18n.t('post.overview')}>{post.overview}</WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('post.highlight')}>{post.highlight}</WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('post.itinerary')}>{post.itinerary}</WithLabel>
      </ListItem>

      <ListItem separate={true}>
        <h4>{I18n.t('direct_reservation.guest_info')}</h4>
      </ListItem>

      <ListItem>
        <WithLabel label={I18n.t('direct_reservation.guest_name')}>
          {reservation.guest_name}
        </WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('direct_reservation.guest_email')}>
          {reservation.guest_email}
        </WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('direct_reservation.memo')}>{reservation.memo}</WithLabel>
      </ListItem>
      <ListItem>
        <WithLabel label={I18n.t('reservation.pickup_location')}>
          {reservation.pickup_location}
        </WithLabel>
      </ListItem>
      <ListItem>
        <InlineGoogleMap
          setMap={setMap}
          setMarker={setMarker}
          latitude={reservation.pickup_latitude}
          longitude={reservation.pickup_longitude}
        />
      </ListItem>
      <S.Buttons>
        <Button primary={false} handleClick={cancel}>
          {I18n.t('generic.back_to_edit')}
        </Button>
        <Button primary={true} handleClick={save} disabled={isProcessing}>
          {I18n.t('generic.create')}
        </Button>
      </S.Buttons>
    </S.Reservation>
  )
}

const directReservationConfirmation = (post_data, values, props) => {
  window.globalModal.showModal({
    title: I18n.t('reservation.reservation_preview'),
    body: <DirectReservationDetail post_data={post_data} data={values} props={props} />,
  })
}

const S: { [key: string]: AnyStyledComponent } = {}
S.Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
S.Reservation = styled.div`
  padding: 12px 0;
  max-width: 880px;
  margin: 0 auto;
  .back {
    padding: 16px;
  }

  .person {
    display: flex;
    align-items: center;
    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      align-items: flex-start;
      flex-direction: column;
    }
  }
  .nb_of {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-right: 20px;
  }
`
export default directReservationConfirmation
